<mat-accordion class="custom-accordion w-p-100">
    <mat-expansion-panel [expanded]='isExpanded' (opened)="changeExpand(true)" (closed)="changeExpand(false)">
        <mat-expansion-panel-header>
            <mat-panel-title class="flex flex-row justify-between items-center">
                <div style="width:100%">
                    <div class="flex flex-row justify-start items-center">
                        <div class="text-left full-grow-no-shrink-no-basis p-l-5">
                            {{dialogField.title}}
                        </div>
                    </div>
                </div>

                <div class="flex flex-row justify-start items-center">
                    @if(groupErrors >0){ <button type="button" (click)="$event.stopPropagation();" mat-button
                        class="warning-btn">
                        <i class="fa-solid fa-hexagon-exclamation"></i>
                        <span>{{groupErrors}}</span>
                    </button>
                    }


                    @if(dialogField.fieldValues['IsMultiResponseField'] && !dialogField.fieldValues['IsMultiResponsePage'] && !dialogField.isDisabled){
                    <button type="button" mat-icon-button class="toolbar-dropdown-btn light" matTooltip="Delete Section"
                        matTooltipPosition="above" (click)="deleteSection($event)">
                        <i class="fa-regular fa-trash"></i>
                    </button>
                    }
                </div>
            </mat-panel-title>
        </mat-expansion-panel-header>

        <ng-template matExpansionPanelContent>
            <app-elite-form-response-page-single-section [eliteFormId]="eliteFormId" [platformDialog]="platformDialog"
                [inputForm]="inputForm" [itemId]="this.itemId" (fieldValueChanges)="onFieldValueChange($event)">
            </app-elite-form-response-page-single-section>
        </ng-template>


    </mat-expansion-panel>
</mat-accordion>
